import { EventType, PublicClientApplication } from '@azure/msal-browser'
import { isAzureAuthEnabled } from './authMode'
import { msalConfig } from './msalConfig'

export const msalInstance = isAzureAuthEnabled ? new PublicClientApplication(msalConfig) : null

if (msalInstance) {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload &&
      'account' in event.payload &&
      event.payload.account
    ) {
      msalInstance.setActiveAccount(event.payload.account)
    }
  })
}
